/**
 * Check if a pathname is a login-related route that should not be stored as a redirect target
 */
export function isLoginRoute(pathname: string): boolean {
  return pathname.startsWith("/login") || pathname === "/login";
}

/**
 * Get a safe redirect target that avoids login routes and root path
 * @param currentPath - The current pathname
 * @param existingTo - Any existing 'to' parameter
 * @param fallback - Fallback path if current path is a login route (defaults to undefined)
 * @returns A safe redirect target, or undefined if no meaningful redirect target exists
 */
export function getSafeRedirectTarget(
  currentPath: string,
  existingTo?: string,
  fallback?: string,
): string | undefined {
  // If current path is not a login route and not root, use it
  if (!isLoginRoute(currentPath) && currentPath !== "/") {
    return currentPath;
  }

  // If current path is a login route or root, try to use existing 'to' param if it's valid
  if (existingTo && !isLoginRoute(existingTo) && existingTo !== "/") {
    return existingTo;
  }

  // Fall back to the provided fallback (if any)
  return fallback;
}
